import React, { useContext, useEffect, useState } from "react";
import ContentFormSquelette from "../layouts/ContentFormSquelette";
import Form from "../components/Form";
import InputText from "../components/InputText";
import NavigationLittleOptions from "./NavigationLittleOptions";
import { createAccount } from "../services/comptes-users";
import { AuthContext } from "../contexts/AuthContext";
import { Link } from "react-router-dom";
import InputPassword from "./InputPassword";
import PasswordRequirements from "./PasswordRequirements";

export default function Signup() {
  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [responseCreateAccount, setResponseCreateAccount] = useState(null);
  const { user } = useContext(AuthContext);


  useEffect(() => {
    if (prenom && nom) {
      const normalize = (s) =>
        s
          .trim()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/\s+/g, "");
      const prenomPropre = normalize(prenom);
      const nomPropre = normalize(nom);
      setUsername(
        `@${prenomPropre + nomPropre}${(nom + prenom).length}`.toLowerCase()
      );
    } else {
      setUsername("");
    }
  }, [prenom, nom]);
  return (
    <>
      <ContentFormSquelette>
        <form
          onSubmit={(evt) => {
            evt.preventDefault();
            if (password === passwordConfirm) {
              createAccount(
                {
                  nom,
                  prenom,
                  username,
                  password,
                },
                // user.token,
                setResponseCreateAccount
              );
            } else {
              setResponseCreateAccount({
                status: 400,
                msg: "Les mots de passes sont différents",
              });
              setTimeout(() => {
                setResponseCreateAccount(null);
              }, 1000 * 10);
            }
            setPrenom("");
            setNom("");
            setPassword("");
            setPasswordConfirm("");
            setUsername("");
          }}
        >
          <Form
            faire="Créer un compte"
            colClasses="col-xl-6 col-lg-8  animate__animated animate__fadeInDownBig"
            hideLogo
          >
            <div className="row g-3 gx-4">
              <InputText
                label="Prénom"
                placeholder="Saisissez votre prénom"
                col="col-sm-6"
                value={prenom}
                onChange={(e) => setPrenom(e.target.value)}
              />
              <InputText
                label="Nom"
                placeholder="Saisissez votre nom"
                col="col-sm-6"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
              />
              <InputText
                label="Nom d'utilisateur (généré automatiquement)"
                placeholder="Nom d'utilisateur"
                col="col-12"
                readOnly
                value={username}
              />
              <InputPassword
                label="Mot de passe"
                placeholder="Mot de passe"
                col="col-12"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="col-12">
                <small className="text-muted">
                  Le mot de passe doit contenir :
                </small>
                <PasswordRequirements password={password} />
              </div>
              <InputPassword
                label="Confirmer le mot de passe"
                placeholder="Confirmer le mot de passe"
                col="col-12"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
              />
                    <div className="col-12">
                      <button
                        className="btn btn-primary w-100"
                        disabled={
                          nom === "" ||
                          prenom === "" ||
                          password === "" ||
                          passwordConfirm === "" ||
                          password.length > 32
                        }
                      >
                        Créer un compte
                      </button>
                    </div>
              <div
                className={`${
                  responseCreateAccount
                    ? ` col-12 ${
                        responseCreateAccount.status === 400 ||
                        responseCreateAccount.status === 500
                          ? "text-danger"
                          : "text-success"
                      }  `
                    : "d-none"
                }`}
              >
                {responseCreateAccount ? (
                  <>
                    <small className="mb-1">{responseCreateAccount.msg}</small>
                    {responseCreateAccount.errors &&
                      responseCreateAccount.errors.length > 0 && (
                        <ul className="mb-0 ps-3" style={{ fontSize: "10px" }}>
                          {responseCreateAccount.errors.map((err, i) => (
                            <li key={i}>{err.message}</li>
                          ))}
                        </ul>
                      )}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Form>
        </form>
        <div className="text-center mt-4 animate__animated animate__delay-1s animate__bounceInLeft">
          <Link to="/">
            Avez-vous un compte?{" "}
            <span className="text-primary">Se connecter</span>
          </Link>
        </div>
      </ContentFormSquelette>
    </>
  );
}
